import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import type { TemporarilyUnavailableRecord } from '@navio/nsdk';
import type { BookingStoreCar } from 'noddi-types';
import { NoddiButton, NoddiDialog, NoddiInfoBanner } from 'noddi-ui-web';
import { formatLicensePlate } from 'noddi-util';

type TemporarilyUnavailableModalProps = {
  open: boolean;
  onClose: () => void;
  reason: TemporarilyUnavailableRecord;
  affectedCars?: BookingStoreCar[];
  onRemoveCar?: (car: BookingStoreCar) => void;
};

export const TemporarilyUnavailableModal = ({
  open,
  onClose,
  reason,
  affectedCars,
  onRemoveCar
}: TemporarilyUnavailableModalProps) => (
  <NoddiDialog open={open} onClose={onClose} title={t`Service unavailable`}>
    <div className='flex flex-col gap-4'>
      <NoddiInfoBanner variant='warning' title={reason.title} texts={[{ value: reason.message }]} />
      {!!affectedCars?.length && !!onRemoveCar && (
        <div className='flex flex-col gap-2'>
          <p className='text-sm text-muted-foreground'>
            <Trans>Remove the affected cars from this booking to continue.</Trans>
          </p>
          {affectedCars.map((car) => (
            <div
              key={car.licensePlate.number}
              className='flex items-center justify-between gap-3 rounded-lg border p-3'
            >
              <div className='flex flex-col text-sm'>
                <span className='font-medium'>{car.make}</span>
                <span className='text-muted-foreground'>{formatLicensePlate(car.licensePlate.number)}</span>
              </div>
              <NoddiButton variant='outline' size='small' onClick={() => onRemoveCar(car)}>
                <Trans>Remove car from booking</Trans>
              </NoddiButton>
            </div>
          ))}
        </div>
      )}
    </div>
  </NoddiDialog>
);
